import { IconConfig } from "../types";

export const umbrella: IconConfig = {
  type: 'fill' as const,
  viewBox: "0 0 16 16", // viewBox par défaut, à ajuster selon le contexte
  paths: ["M13.815 7.482a1.65 1.65 0 0 1 1.29.988h.767a7.9 7.9 0 0 0-2.267-5.376A8.26 8.26 0 0 0 8.546.587a.87.87 0 0 0-1.644 0 7.664 7.664 0 0 0-6.9 7.741 1 1 0 0 0 .015.145h.832a1.65 1.65 0 0 1 1.347-.988 1.465 1.465 0 0 1 1.393.988h.755a1.3 1.3 0 0 1 1.259-.98 1.323 1.323 0 0 1 1.3 1.244v4.513c0 .355 0 .919-.511.919a.55.55 0 0 1-.633-.61v-.813H4.117v.813a2.2 2.2 0 0 0 2.289 2.316 2.27 2.27 0 0 0 1.66-.713 2.68 2.68 0 0 0 .515-1.911V8.702c.076-.984.912-1.209 1.6-1.209a1.59 1.59 0 0 1 1.444.977h.782a1.49 1.49 0 0 1 1.408-.988"]
}
